<template>
  <div class="operation-panel">
    <div class="top-section">
      <QuestionList @ask-question="(q) => $emit('ask-question', q)" />
    </div>
    <div class="middle-section">
      <ActionButtons @open-chat="$emit('open-chat')" @open-map="$emit('open-map')" @open-brand-list="$emit('open-brand-list')" />
    </div>
    <div class="bottom-section">
      <FeatureSection @open-chat-with-context="(data) => $emit('open-chat-with-context', data)" />
    </div>
  </div>
</template>

<script>
import QuestionList from './QuestionList.vue'
import ActionButtons from './ActionButtons.vue'
import FeatureSection from './FeatureSection.vue'

export default {
  name: 'OperationPanel',
  components: {
    QuestionList,
    ActionButtons,
    FeatureSection
  },
  emits: ['open-chat', 'open-map', 'open-chat-with-context', 'ask-question', 'open-brand-list']
}
</script>

<style scoped>
.operation-panel {
  display: flex;
  flex-direction: column;
  gap: 1.5vh; /* Relaxed gap slightly */
  height: 100%;
  padding: 1vh 4vw; /* Reduced vertical padding to increase content height */
  box-sizing: border-box;
}

.top-section {
  flex: 5;
  min-height: 0;
  position: relative;
}

.middle-section {
  flex: 1.2;
  min-height: 0;
}

.bottom-section {
  flex: 3.8;
  min-height: 0;
  overflow: hidden;
}
</style>
